import { Flex, Steps } from 'antd';
import styled from 'styled-components';
import { maxWidth } from 'config/constants';

export const StepsContainer = styled(Steps)`
  &.ant-steps.ant-steps-label-vertical .ant-steps-item-icon {
    margin-inline-start: 60px;
  }

  &.ant-steps .ant-steps-item .ant-steps-item-icon {
    width: 16px;
    height: 16px;
    margin-inline-end: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.ant-steps .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon-dot {
    width: 8px;
    height: 8px;
    background: #b7b7b7;
    top: 1px;
  }

  &.ant-steps .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon-dot {
    width: 16px;
    height: 16px;
    background: #000000;
    top: 2px;
  }

  &.ant-steps .ant-steps-item .ant-steps-item-tail {
    top: 8px;
    left: 2px;
  }

  &.ant-steps .ant-steps-item .ant-steps-item-tail::after {
    height: 1.5px;
    border-radius: 0;
    width: calc(100% - 32px);
  }

  &.ant-steps .ant-steps-item-process .ant-steps-item-tail::after,
  &.ant-steps .ant-steps-item-wait .ant-steps-item-tail::after {
    background-color: #b7b7b7;
  }

  .ant-steps-item-title {
    font-weight: 700;
    font-size: 14px;
  }

  .ant-steps-item-content {
    margin-top: 6px;
  }

  ${maxWidth.m} {
    padding: ${(props): string => props.theme.kcc.spacing.XXL} 23px 38px 23px;

    .ant-steps-item-title {
      display: none;
    }

    &.ant-steps.ant-steps-label-vertical .ant-steps-item-icon {
      margin-inline-start: 32px;
    }

    .ant-steps-item-container {
      width: 80px;
    }

    .ant-steps-item-container > .ant-steps-item-content {
      width: 80px;
    }

    &.ant-steps .ant-steps-item-tail {
      margin-inline-start: 56px;
    }

    &.ant-steps .ant-steps-item-tail::after {
      margin-inline-start: 0px;
    }

    &.ant-steps .ant-steps-item .ant-steps-item-tail {
      left: 0;
    }
  }
`;

export const CheckDotWrapper = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
`;
